/**
 * LeadDetailPage — Iter 156.11
 * Thin shell: composes `useLeadDetail` state with sub-components in /lead-detail.
 */
import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import useLeadDetail from "./lead-detail/useLeadDetail";
import LeadDetailHeader from "./lead-detail/LeadDetailHeader";
import MessageThread from "./lead-detail/MessageThread";
import LeadDetailsCard from "./lead-detail/LeadDetailsCard";
import LeadOrdersCard from "./lead-detail/LeadOrdersCard";
import LeadRemindersCard from "./lead-detail/LeadRemindersCard";
import AddOrderDialog from "./lead-detail/AddOrderDialog";
import AddReminderDialog from "./lead-detail/AddReminderDialog";

const LeadDetailPage = () => {
  const { leadId } = useParams();
  const { user } = useAuth();
  const s = useLeadDetail(leadId, user);

  if (s.loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="spinner" />
      </div>
    );
  }

  if (!s.lead) {
    return <div>Lead not found</div>;
  }

  return (
    <div data-testid="lead-detail-page">
      <LeadDetailHeader lead={s.lead} />

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <MessageThread
          messages={s.messages}
          newMessage={s.newMessage}
          setNewMessage={s.setNewMessage}
          sendViaWhatsApp={s.sendViaWhatsApp}
          setSendViaWhatsApp={s.setSendViaWhatsApp}
          sendingMessage={s.sendingMessage}
          onSend={s.handleSendMessage}
        />

        <div className="lg:col-span-3 space-y-6">
          <LeadDetailsCard
            lead={s.lead}
            user={user}
            salespeople={s.salespeople}
            onUpdate={s.handleUpdateLead}
          />

          <LeadOrdersCard
            orders={s.orders}
            user={user}
            onAddClick={() => s.setShowOrderDialog(true)}
            onDelete={s.handleDeleteOrder}
          />

          <LeadRemindersCard
            reminders={s.reminders}
            onAddClick={() => s.setShowReminderDialog(true)}
            onComplete={s.handleCompleteReminder}
          />
        </div>
      </div>

      <AddOrderDialog
        open={s.showOrderDialog}
        onOpenChange={s.setShowOrderDialog}
        orderData={s.orderData}
        setOrderData={s.setOrderData}
        onSubmit={s.handleCreateOrder}
      />

      <AddReminderDialog
        open={s.showReminderDialog}
        onOpenChange={s.setShowReminderDialog}
        reminderData={s.reminderData}
        setReminderData={s.setReminderData}
        onSubmit={s.handleCreateReminder}
      />
    </div>
  );
};

export default LeadDetailPage;
